<div class="alarm-notification">
    <div class="latest-alarm-container">
        <div
            [ngClass]="[
                'alarms',
                responsive.screenSize,
                responsive.deviceAndOrientation,
            ]"
        >
            <div
                class="latest-alarm-noti"
                [ngStyle]="!latestAlarm && { width: '457px' }"
            >
                <div class="alarm-info-wrap" *ngIf="latestAlarm">
                    <div
                        data-cy="latest-alarm-container"
                        class="alarm-info"
                        *ngIf="latestAlarm"
                    >
                        <app-alarm-status-icon
                            [statusText]="latestAlarm.level"
                        ></app-alarm-status-icon>
                        <p data-cy="latest-alarm-channel-name">
                            {{ latestAlarm.name }}
                        </p>
                        <span data-cy="latest-alarm-time">{{
                            latestAlarm.occurredAt | date: "HH:mm:ss"
                        }}</span>
                    </div>
                    <button
                        data-cy="latest-alarm-ack-button"
                        (click)="onClickAck(latestAlarm)"
                        [disabled]="shouldDisableButton(latestAlarm)"
                        class="ack-btn primary"
                    >
                        ACK
                    </button>
                </div>
                <div class="open-window-btn">
                    <mat-icon
                        data-cy="expand-active-alarms-button"
                        svgIcon="chevron"
                        *ngIf="latestAlarm"
                        (click)="onAlarmWindowShow()"
                        [ngStyle]="{
                            transform: isAlarmWindowClosed
                                ? 'rotate(270deg)'
                                : 'rotate(90deg)',
                        }"
                    ></mat-icon>
                </div>
            </div>
            <div class="nav-alarm">
                <mat-icon data-cy="bell-icon" svgIcon="alarm" />
                <p data-cy="alarm-counter" class="alarm">
                    {{ getNumberAlarms() }}
                </p>
                <p data-cy="caution-counter" class="caution">
                    {{ getNumberCaution() }}
                </p>
                <p data-cy="warning-counter" class="warn">
                    {{ getNumberWarning() }}
                </p>
            </div>
        </div>
    </div>
</div>
